import { useMutation } from '~/utils/rq';

type IPMatchingUpdateResponse = {
  enablement_status: 'auto' | 'manual' | 'migration' | null;
  is_enabled: boolean;
  ids: any[];
};

export const useUpdateIPMatching = (campaignId?: string) => {
  const URL = `/admin/campaigns/${campaignId}/ip-matching`;

  return useMutation<any, IPMatchingUpdateResponse>(
    {},
    {
      method: 'patch',
      url: URL
    }
  );
};

type IPMatchingCreateIdsResponse = {
  enablement_status: 'auto' | 'manual' | 'migration' | null;
  errors?: string[] | string;
  is_enabled: boolean;
  ids: any[];
};

export const useCreateIPMatchingIDs = (campaignId?: string) => {
  const URL = `/admin/campaigns/${campaignId}/ip-matching/ids`;

  return useMutation<any, IPMatchingCreateIdsResponse>(
    {},
    {
      method: 'post',
      url: URL
    }
  );
};
